module.exports = __webpack_public_path__ + "static/img/rank_background2.94dae6a8.png";